import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const styles = {
  activityRow: css`
    display: flex;
    flex-flow: row;
    gap: ${theme.spacing(2)};
    align-items: center;
  `,
  activityDetail: (compactView: boolean) => css`
    display: flex;
    flex-direction: row;
    gap: ${theme.spacing(1)};
    align-items: ${compactView ? 'flex-start' : 'center'};
  `,
  blackInk: css`
    color: ${theme.colorsV2.black(75)};
  `,
  marginBottom: css`
    margin-bottom: ${theme.spacing(2)};
  `,
  userBadge: css`
    display: flex;
    align-items: center;
    gap: ${theme.spacing(1)};
    color: ${theme.colorsV2.black(75)};
  `,
};
